import Vue from 'vue';
import Router from 'vue-router';
import { setTitle } from '@/utils';
import wechat from '@/utils/platformUtils/wechat';
import env from '@/utils/env';
// import InitCKBusiness from '@hb/ckbusiness';
import Crow from '@/utils/crow';
import goToNewDrivApply from '@/router/goToNewDrivApply';
import Native from '@/utils/nativeProxy';
// import getDriverGrowthSystemGrey from './getDriverGrowthSystemGrey';
import defaultRoutes from './routes';
import drivApplyRoutes from './drivApplyRoutes';

let firstEnterFlag = true;

Vue.use(Router);

const router = new Router({
  routes: [
    ...defaultRoutes,
    ...drivApplyRoutes,
  ],
});

router.beforeEach(async (to, from, next) => {
  if (
    to.name === 'audit'
    || to.name === 'driver-register'
    || to.name === 'driv-apply-simplified/add-driv-info'
    || to.name === 'edit-car-info/edit'
  ) {
    const isBlock = await goToNewDrivApply(to.name, to.query, next);
    if (isBlock) {
      return;
    }
  }
  // if (to.name === 'your-details') {
  //   const res = await getDriverGrowthSystemGrey();
  //   if (res) {
  //     next({
  //       name: 'your-details-v2',
  //       query: to.query,
  //       replace: true,
  //     });
  //     return;
  //   }
  // }
  if (env.isEasyBikeApp || env.isHitchIndepApp) {
    if (to.query && (+to.query.hiddenNavigationBar === 1)) {
      Native.showNaviBar(false);
    }
  }
  const { title } = to.meta;
  if (title) setTitle(title);
  Crow.send({ keyword: '页面跳转', url: to.fullPath });
  if (env.isWeixin && firstEnterFlag) {
    firstEnterFlag = false;
    const res = await wechat.inWxMinipro();
    if (res) {
      env.isWeixinMp = true;
    }
    next();
    // if (!res) {
    //   if (process.env.VUE_APP_ENV !== 'dev') {
    //     new InitCKBusiness(6, false).checkHost(); // 判断域名是否是m2.hellobike.com 否则同步抛错
    //   }
    //   next();
    // } else {
    //   env.isWeixinMp = true;
    //   next();
    // }
  }
  next();
});

export default router;
